import { Injectable } from '@angular/core';

export enum Tip {
  TeamAlbums = 'team_albums',
  UserAlbums = 'user_albums',
}

@Injectable()
export class TipsService {
  private getKey(tip: Tip): string {
    return `uploadcam_${tip}`;
  }

  public hide(tip: Tip): void {
    localStorage.setItem(this.getKey(tip), 'closed');
  }

  public isHidden(tip: Tip): boolean {
    return !!localStorage.getItem(this.getKey(tip));
  }
}
